// src/pages/CreateTemplatePage.js
import React from 'react';
import Header from '../components/Header';
import TemplateForm from '../components/TemplateForm';

const CreateTemplatePage = () => {
  return (
    <div>
      <Header title="Create Template" />
      <div style={{ padding: 16, marginTop: 24 }}>
        <TemplateForm onSave={() => {}} />
      </div>
    </div>
  );
};

export default CreateTemplatePage;
